var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photo-modal-wrapper"},[_c('div',{staticClass:"photo-modal"},[_c('Cornerstone',{attrs:{"path":_vm.path,"category":_vm.category,"advanced":true},on:{"close":function($event){return _vm.$emit('close')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }